import { render, staticRenderFns } from "./YearFilter.vue?vue&type=template&id=04ff14da&scoped=true&"
import script from "./YearFilter.vue?vue&type=script&lang=js&"
export * from "./YearFilter.vue?vue&type=script&lang=js&"
import style0 from "./YearFilter.vue?vue&type=style&index=0&id=04ff14da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ff14da",
  null
  
)

export default component.exports